import { UcoastEl } from '@/scripts/core/UcoastEl'
import {formatPhoneNumber, getOrThrow, getOrUndefined, qsOptional, qsRequired} from "@/scripts/core/global";
import {KlaviyoOosPopup} from "@/scripts/theme/klaviyo-oos-popup";

export class KlaviyoOosForm extends UcoastEl {
    static htmlSelector = 'klaviyo-oos-form'
    form: HTMLFormElement
    submitButton: HTMLButtonElement
    emailInput: HTMLInputElement
    successEl: HTMLElement
    route: string
    popup?: KlaviyoOosPopup
    variant?: string
    constructor() {
        super()
        this.form = qsRequired('form', this)
        this.submitButton = qsRequired('[type="submit"]', this)
        this.emailInput = qsRequired('[type="email"]', this)
        this.successEl = qsRequired('[data-uc-form-status]', this)
        this.route = 'https://a.klaviyo.com/client/back-in-stock-subscriptions?company_id=PTtQzt'
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this))
        this.popup = qsOptional<KlaviyoOosPopup>('notify-me', this)
    }

    renderSuccess() {
        this.emailInput.value = ''
        this.successEl.classList.remove('hidden')
        this.submitButton.classList.add('success')
        this.emailInput.placeholder = 'Thanks for signing up'
        if (this.popup) {
            window.setTimeout(() => {
                this.popup?.hide()
            }, 5000)
        }
        this.submitButton.classList.remove('loading')
        this.submitButton.removeAttribute('aria-disabled')
    }

    renderError() {
        this.emailInput.value = ''
        this.emailInput.placeholder = 'This email address is invalid.'
        this.submitButton.classList.remove('loading')
        this.submitButton.removeAttribute('aria-disabled')
    }

    onSubmitHandler(event: Event) {
        event.preventDefault()
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return
        if (this.emailInput.value.length < 1) {
            this.renderError()
        }

        this.submitButton.setAttribute('aria-disabled', 'true')
        this.submitButton.classList.add('loading')

        const formData = new FormData(this.form)

        const config = this.notifyMeConfig(formData)

        fetch(this.route, config)
            .then((response) => response.text())
            .then((response) => {

                if (response?.length) {
                    this.renderError()
                    return
                }
                this.renderSuccess()
            })
            .catch((e) => {
                this.renderError()
                console.error(e)
            })
    }

    notifyMeConfig(body: FormData) {
        const values = {
            email: getOrThrow(body, 'email'),
            variant: getOrThrow(body, 'variant'),
            phone_number: getOrUndefined(body, 'phone_number'),
            language_iso: getOrUndefined(body, 'language_iso') ?? 'en',
            market_handle: getOrUndefined(body, 'market_handle') ?? 'us',
        }
        if (values.phone_number) {
            values.phone_number = formatPhoneNumber(values.phone_number)
        }
        return {
            method: 'POST',
            headers: {
                accept: 'application/json',
                Revision: '2024-05-15',
                'content-type': 'application/json',
            },
            body: JSON.stringify({
                data: {
                    type: 'back-in-stock-subscription',
                    attributes: {
                        channels: ['EMAIL', 'SMS'],
                        profile: {
                            data: {
                                type: 'profile',
                                attributes: {
                                    email: values.email,
                                    phone_number: values.phone_number
                                },
                            },
                        },
                    },
                    relationships: {
                        variant: {
                            data: {
                                type: 'catalog-variant',
                                id: `$shopify:::$default:::${values.variant}`,
                            },
                        },
                    },
                },
            }),
        }
    }
}
